var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.width,
        height: _vm.height,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _vm.iconType === "success"
        ? _c("path", {
            attrs: {
              d: "M8.99996 0.666504C4.39996 0.666504 0.666626 4.39984 0.666626 8.99984C0.666626 13.5998 4.39996 17.3332 8.99996 17.3332C13.6 17.3332 17.3333 13.5998 17.3333 8.99984C17.3333 4.39984 13.6 0.666504 8.99996 0.666504ZM7.33329 13.1665L3.16663 8.99984L4.34163 7.82484L7.33329 10.8082L13.6583 4.48317L14.8333 5.6665L7.33329 13.1665Z",
              fill: "#0DB010",
            },
          })
        : _c("path", {
            attrs: {
              d: "M9.99984 1.66699C5.39984 1.66699 1.6665 5.40033 1.6665 10.0003C1.6665 14.6003 5.39984 18.3337 9.99984 18.3337C14.5998 18.3337 18.3332 14.6003 18.3332 10.0003C18.3332 5.40033 14.5998 1.66699 9.99984 1.66699ZM10.8332 14.167H9.1665V12.5003H10.8332V14.167ZM10.8332 10.8337H9.1665V5.83366H10.8332V10.8337Z",
              fill: "#EE6917",
            },
          }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }